"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _DraggableHeader = _interopRequireDefault(require("../DraggableHeader"));

var _Add = _interopRequireDefault(require("./Add"));

var _Header = _interopRequireDefault(require("./Header"));

var _Selected = _interopRequireDefault(require("./Selected"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getHeader = function getHeader(type) {
  if (type === "add") {
    return _Add["default"];
  }

  if (type === "selected") {
    return _Selected["default"];
  }

  if (type === "empty") {
    return null;
  }

  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_DraggableHeader["default"], _extends({}, props, {
      render: _Header["default"]
    }));
  };
};

exports.getHeader = getHeader;